import { AverageOrderPreparationTimeInterface, CompanyDetailsInterface } from '../../services/exports/Interfaces';
import { DeliveryMode, ORDER_METHODS } from '../../services/exports/Constants';
import moment from 'moment/moment';
import { useSelector } from 'react-redux';
import { selectCachedOrder } from '../../store/slices/OrderSlice';

type OrderPreparationTimeFunction = (method?: ORDER_METHODS) => AverageOrderPreparationTimeInterface;

export default function useOrderPreparationTime(company: CompanyDetailsInterface): OrderPreparationTimeFunction {
  const cachedOrder = useSelector(selectCachedOrder);
  const order = cachedOrder?.company_id === company?.id ? cachedOrder : null;
  const getDeliveryTime = (): AverageOrderPreparationTimeInterface => {
    if (company?.delivery_mode === DeliveryMode.External && order?.delivery_quote?.dropoff_estimate) {
      return {
        min: moment(order?.delivery_quote?.dropoff_estimate).diff(moment(), 'minute'),
        max: moment(order?.delivery_quote?.dropoff_estimate).add(10, 'minutes').diff(moment(), 'minute'),
      };
    }

    return company?.average_order_delivery_time;
  };

  return (method?: ORDER_METHODS): AverageOrderPreparationTimeInterface => {
    return (
      {
        [ORDER_METHODS.PICKUP]: company?.average_order_preparation_time,
        [ORDER_METHODS.ON_SITE]: company?.average_order_preparation_time,
        [ORDER_METHODS.DELIVERY]: getDeliveryTime(),
      }[method ?? order?.method] ?? company?.average_order_preparation_time
    );
  };
}
